import './i18n/config';
import React, {Suspense} from "react";
import ReactDOM from 'react-dom/client';
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import store from "./redux";
import {persistStore} from "redux-persist";
import Loader from "./components/Loader/Loader";

if (process.env.NODE_ENV === "production") {
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
}

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Loader/>}>
                <App/>
            </Suspense>
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
